export default __webpack_public_path__ + "static/article-3-9d6310f5c06488c012d00ab266190e50.jpg";